import React, {Fragment} from 'react';
import loadable from '@loadable/component';
import {
    CACHE as LOADING_CACHE,
    placeholderFromType,
} from '../../components/common/loading';

const AsyncDestinationUrgencyLoadable = loadable(
    () =>
        import(
            /* webpackChunkName: "destination-urgency" */
            /* webpackPrefetch: true */
            './'
        ),
    {ssr: false}
);

export const AsyncDestinationUrgency = () => {
    const componentPlaceholder = placeholderFromType(AsyncDestinationUrgency); // eslint-disable-line no-use-before-define

    const element = (
        <AsyncDestinationUrgencyLoadable
            fallback={<Fragment>{componentPlaceholder}</Fragment>}
        />
    );

    return element;
};

AsyncDestinationUrgency.displayName = 'AsyncDestinationUrgency';

LOADING_CACHE.set(AsyncDestinationUrgency, {
    componentType: 'AsyncDestinationUrgency',
    placeholderType: 'Block',
    size: 'xsm',
});
